export default __webpack_public_path__ + "static/media/ArjunVegda.5570af17.jpg";